








































import { defineComponent, PropType } from '@vue/composition-api';

export default defineComponent({
  props: {
    tabNo: {
      type: Number as PropType<number>,
      required: true
    },
    showUploadButton: {
      type: Boolean as PropType<boolean>,
      default: true
    },
  },
  setup(props, context){

    const toCampusList = () => {
      context.root.$router.push(`/teacher_site/campus_list`);
    };

    const toCourseList = () => {
      context.root.$router.push(`/teacher_site/course_list`);
    };

    const toClassificationList = () => {
      context.root.$router.push(`/teacher_site/classification_list`);
    };
    
    const toCurriculumList = () => {
      context.root.$router.push(`/teacher_site/curriculum_list`);
    };

    const toSubjectList = () => {
      context.root.$router.push(`/teacher_site/subject_list`);
    };

    const toStudentList = () => {
      context.root.$router.push(`/teacher_site/student_list`);
    };

    const toStudentSubjectList = () => {
      context.root.$router.push(`/teacher_site/student_subject_list`);
    };

    const toStudentSubjectReportList = () => {
      context.root.$router.push(`/teacher_site/student_subject_report_list`);
    };

    const toLessonList = () => {
      context.root.$router.push(`/teacher_site/lesson_list`);
    };

    const toUpload = () => {
      
      if(props.tabNo == 1){
        context.root.$router.push(`/teacher_site/course_upload`);
      }else if(props.tabNo == 2){
        context.root.$router.push(`/teacher_site/campus_upload`);
      }else if(props.tabNo == 3){
        context.root.$router.push(`/teacher_site/classification_upload`);
      }else if(props.tabNo == 4){
        context.root.$router.push(`/teacher_site/curriculum_upload`);
      }else if(props.tabNo == 5){
        context.root.$router.push(`/teacher_site/subject_upload`);
      }else if(props.tabNo == 6){
        context.root.$router.push(`/teacher_site/student_upload`);
      }else if(props.tabNo == 7){
        context.root.$router.push(`/teacher_site/student_subject_upload`);
      }else if(props.tabNo == 8){
        context.root.$router.push(`/teacher_site/lesson_upload`);
      }else if(props.tabNo == 9){
        context.root.$router.push(`/teacher_site/student_subject_report_upload`);
      }
    };

    return {
      toCampusList,
      toCourseList,
      toClassificationList,
      toCurriculumList,
      toSubjectList,
      toStudentList,
      toStudentSubjectList,
      toStudentSubjectReportList,
      toLessonList,
      toUpload,
    };
  }
})
